import { getPreviousQuotesThunk } from './quoteThunk';
import { createSlice } from "@reduxjs/toolkit";
import { iApiError } from "../../types/commonTypes";
import { DEFAULT_API_ERROR } from '../../constants/commonConstants';

export interface IQuotesStoreState {
	totalBidsCount: number | null;
  apiError: iApiError | null;
}

const initialState: IQuotesStoreState = {
	totalBidsCount: null,
  apiError: null,
};

const quotesSlice = createSlice({
	name: "quotes",
	initialState,
	reducers: {
    resetQuotesState(state) {
      state.totalBidsCount = null;
      state.apiError = null;
    },
  },
	extraReducers(builder) {
		builder.addCase(getPreviousQuotesThunk.pending, (state) => {
			state.apiError = null;
		});
		builder.addCase(getPreviousQuotesThunk.fulfilled, (state, action) => {
			state.totalBidsCount = action.payload?.totalBidsCount ?? 0;
		});

		builder.addCase(getPreviousQuotesThunk.rejected, (state, action) => {
			state.apiError = action.payload ?? DEFAULT_API_ERROR;
		});
	},
});

export const { resetQuotesState } = quotesSlice.actions;
export default quotesSlice.reducer;
